import React, { useState, useEffect } from "react";
import "./NewsForm.css";
import {
	createNews,
	clearNewsStatus,
	updateStatus,
	fetchNewsStatusById,
} from "../../ApiController/newsApi";

const NewsForm = ({setDataChanged}) => {
	const maxChars = 500;
	const [newsData, setNewsData] = useState({
		comment: "",
		fromDateTime: "",
		toDateTime: "",
		status: "",
	});
	useEffect(() => {
		const loadNews = async () => {
			let fetchedStatus;
			try {
				if(!sessionStorage.getItem("status")){
				const userId = sessionStorage.getItem("userId");
				fetchedStatus = await fetchNewsStatusById(userId);
				sessionStorage.setItem("status", JSON.stringify(fetchedStatus));
			}else{
				fetchedStatus = JSON.parse(sessionStorage.getItem("status"));
			}
			} catch (error) {
				console.error("Misslyckades med att hämta nyheter:", error);
			}
			setNewsData((prevData) => ({
				...prevData,
				status: fetchedStatus || "",
			}));
		};
		loadNews();
	}, []);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setNewsData({ ...newsData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const teacherId = sessionStorage.getItem("userId");

		try {
			const payload = {
				employeeid: teacherId,
				comment: newsData.comment,
				endDate: newsData.toDate,
				status: newsData.status,
			};

			await createNews(payload);
			alert("Nyheter har skickats in!");
			setDataChanged(true);
			setNewsData({
				comment: "",
				fromDateTime: "",
				toDateTime: "",
				fromDate: "",
				toDate: "",
				status: newsData.status,
			});
			sessionStorage.setItem("status", JSON.stringify(newsData.status)); 
		} catch (error) {
			console.error("Misslyckades med att skicka in nyheter:", error);
			alert("Misslyckades med att skicka in nyheter.");
		}
	};

	const handleClearStatus = async () => {
		const newsId = sessionStorage.getItem("userId");
		try {
			await clearNewsStatus(newsId);
			alert("Status för nyheter rensad!");
			setNewsData({ ...newsData, status: "" });
			sessionStorage.setItem("status", JSON.stringify({})); 
		} catch (error) {
			console.error("Misslyckades med att rensa nyhetsstatus:", error);
			alert("Misslyckades med att rensa nyhetsstatus.");
		}
	};
	

	const handleUpdateStatus = async () => {
		const newsId = sessionStorage.getItem("userId");
	
		try {
			await updateStatus(newsId, newsData.status);
			alert("Status har uppdaterats!");
			sessionStorage.setItem("status", JSON.stringify(newsData.status)); 
		} catch (error) {
			console.error("Misslyckades med att uppdatera status:", error);
			alert("Misslyckades med att uppdatera status.");
		}
	};
	
	const charactersRemaining = maxChars - newsData.comment.length;
	const today = new Date().toISOString().split("T")[0];

	return (
		<form onSubmit={handleSubmit} className="form-container container">
			<div className="form-group">
				<label htmlFor="comment">Nyheter</label>
				<textarea
					id="comment"
					name="comment"
					className="form-control mb-3 custom-textarea-height"
					value={newsData.comment}
					onChange={handleInputChange}
					required
					maxLength={maxChars}
					placeholder="Skriv din nyhet här... (max 500 tecken)"
				/>
				<div className="text-muted">{charactersRemaining} tecken kvar</div>
			</div>

			<div className="form-group">
				<label htmlFor="toDateTime">Slut datum</label>
				<input
					type="date"
					id="toDate"
					name="toDate"
					className="form-control"
					value={newsData.toDate}
					onChange={handleInputChange}
					min={newsData.fromDate || today}
					required
				/>
			</div>

			<div className="mb-3 d-flex align-items-center justify-content-between">
				<label className="form-label me-3">Status:</label>
				{["Tjänsteledig", "Semester", "Hemma"].map((status) => (
					<div className="form-check me-2" key={status}>
						<input
							type="radio"
							id={status}
							name="status"
							className="form-check-input"
							value={status}
							checked={newsData.status === status}
							onChange={handleInputChange}
						/>
						<label className="form-check-label" htmlFor={status}>
							{status.charAt(0).toUpperCase() + status.slice(1)}
						</label>
					</div>
				))}
			</div>

			<div className="d-flex align-items-center justify-content-center">
				<button
					type="button"
					className="custom-btn"
					onClick={handleClearStatus}
				>
					Rensa Status
				</button>
				<button
					type="button"
					className="custom-btn"
					onClick={handleUpdateStatus}
				>
					Skicka Status
				</button>
				<button type="submit" className="custom-btn">
					Skicka Nyhet
				</button>
			</div>
			<div className="d-flex  align-items-center justify-content-center"></div>
		</form>
	);
};

export default NewsForm;
